import { makeAutoObservable } from 'mobx';

export default class Message {
  tip = '';
  /** 与现货 axios_xt4 的 ma 一致，供 i18n 占位符 {0}/{1} 替换 */
  tipMa: string[] = [];
  mcSet = new Set();
  messageModalVisible = false;

  noticeId = '';

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  addMcIntoSet(mc: string) {
    this.mcSet.add(mc);
  }

  clearMcSet() {
    this.mcSet.clear();
  }

  setMessage(msg: string, ma?: string[]) {
    if (!msg) {
      this.tip = '';
      this.tipMa = [];
      return;
    }
    this.tip = msg || 'message.rejected';
    this.tipMa = Array.isArray(ma) && ma.length > 0 ? [...ma] : [];
  }

  setMessageModalVisible(visible: boolean) {
    this.messageModalVisible = visible;
  }

  setnoticeId(noticeId: string) {
    this.noticeId = noticeId || '';
  }
}